import React from 'react';
import { Input } from 'AWS-UI-Components-React';
import { AccuracyButtonNewStyle } from '../../styles/common_styles';
import { Asterisk } from '../buttons/asterisk';

export class InputField extends React.Component {
  render() {
    return (
      <div className={ AccuracyButtonNewStyle }>
        <b> { this.props.text } </b>
        <Asterisk required={this.props.required}/>
        <Input
          value={ this.props.value }
          placeholder={ this.props.placeholder }
          onChange={ this.props.onChange }
          disabled={ this.props.disabled }
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/input_field.jsx